<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      verbose-name="Devis"
      verbose-name-plural="Devis"
      ressource="quotations"
      :additional-params="{ expense: $route.params.expense }"
      :colors="colors"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { Quotation } = Hk.Crm
export default {
  name: 'invoices',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        pending: 'warning',
        accepted: 'success',
        canceled: 'danger',
      },
    }
  },

  mounted() {
    this.transactionClass = Quotation
  },
}
</script>

<style></style>
